<template>
  <v-container fluid pa-0 mt-0 pt-1>
    <v-row>
      <v-col><slot></slot></v-col>
    </v-row>

    <v-layout row v-if="false">
      <v-flex xs12 sm3>
        <v-switch v-model="openAll" label="Open/Close All Days"></v-switch>
      </v-flex>
      <v-flex xs12 sm3>
        <v-switch
          v-model="showAllServices"
          label="Show All Services"
        ></v-switch>
      </v-flex>
    </v-layout>
    <v-expansion-panels multiple v-model="panels">
      <v-expansion-panel v-for="(day, i) in days" :key="i">
        <v-expansion-panel-header>
          <h6 class="title">Day {{ i + 1 }}: {{ day.label }}</h6>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <itinerary-items-list-table
            v-if="day.items.length > 0"
            :headers="headers"
            :visible-columns="visibleColumns"
            :items="day.items"
            :currency-code="currencyCode"
            :disable-row="day.disableRow"
            :basic-comps="basicComps"
            @action="onItemsListAction"
            @supplier-edit="onSupplierEdit"
            @onRecalculate="onRecalculate"
            :flagsEditDisabledFn="flagsEditDisabledFn"
            @showMoveDays="onShowMoveDays"
            @reorderSelectedServices="onReorderSelectedServices"
            @customPriceToggle="onCustomPriceToggle"
            @zeroSelectedServices="onZeroSelectedServices"
            @showPaxUpdater="onShowPaxUpdater"
            @removeSelectedServices="onRemoveSelectedServices"
            @showUpdateStatus="onShowUpdateStatus"
            @showItiComps="onShowItiComps"
            @showRemarksEdit="onShowRemarksEdit"
            @showPriceAdjuster="onShowPriceAdjuster"
            @orderNoChange="onOrderNoChange"
            @refreshPrices="onRefreshPrices"
            @timeChange="onTimeChange"
            @isIncludedChange="onIsIncludedChange"
            @isOptionalChange="onIsOptionalChange"
            :search="search"
          ></itinerary-items-list-table>

          <v-layout justify-center>
            <v-btn
              text
              color="primary"
              @click="onRatesSearch($event, day)"
              v-if="$store.getters.hasAccessTo('third_party:visible')"
            >
              <v-icon left>mdi-magnify</v-icon>Rates Search
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="onAddItem($event, day)"
              v-if="
                !$store.getters.hasAccessTo('itineraries:hide_quick_access')
              "
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>Quick Add
            </v-btn>
            <v-btn text color="primary" @click="onAddAdhoc($event, day)">
              <v-icon left>mdi-plus-circle-outline</v-icon>Add Service
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="onAddTemplate($event, day)"
              v-if="
                !$store.getters.hasAccessTo('itineraries:hide_add_template')
              "
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>Add Template
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="onAddCharge($event, day)"
              v-if="!$store.getters.hasAccessTo('itineraries:hide_add_charge')"
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>Add Charge
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="onAddFromAllocations($event, day)"
              v-if="
                !$store.getters.hasAccessTo('itineraries:hide_add_allocation')
              "
            >
              <v-icon left>mdi-plus-circle-outline</v-icon>Add From Allocations
            </v-btn>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-if="debug">
      <p>
        days:
        <code>{{ JSON.stringify(panels, null, 4) }}</code>
      </p>
    </div>
  </v-container>
</template>

<script>
import ItineraryItemsListTable from "../../shared/ItineraryItemsListTable";

const moment = require("moment");
export default {
  name: "ItineraryBuilderItemsListDayByDay",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
    headers: {
      type: Array,
      default: () => [],
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    currencyCode: {
      type: String,
      default: () => "",
    },
    openAll: {
      type: Boolean,
      default: () => true,
    },
    showAllServices: {
      type: Boolean,
      default: () => true,
    },
    flagsEditDisabledFn: {
      type: Function,
      default: () => false,
    },
    basicComps: {
      type: Boolean,
      default: () => true,
    },
    search: {
      type: String,
      default: "",
    },
  },
  components: { ItineraryItemsListTable },
  data() {
    return {
      debug: false,
      showDays: true,
      panels: [],
    };
  },
  computed: {
    days() {
      const list = [];
      if (this.showDays) {
        if (this.startDate != "" && this.endDate != "") {
          const a = moment(this.startDate).startOf("day");
          const b = moment(this.endDate).startOf("day");
          for (let m = moment(a); m.isSameOrBefore(b); m.add(1, "days")) {
            const dateString = m.toISOString(true);
            const disableRow = (item) =>
              !moment(item.startDate).isSame(moment(dateString), "day");
            list.push({
              label: this.$options.filters.formatDate(dateString),
              disableRow,
              dateString,
              items: this.items.filter((item) => {
                const inclOperator =
                  item.serviceType == "ACCOMMODATION" && !item.isExtra
                    ? "[)"
                    : "[]";
                return this.showAllServices
                  ? m.isBetween(
                      moment(item.startDate).startOf("day"),
                      moment(item.endDate).startOf("day"),
                      "day",
                      inclOperator
                    ) ||
                      (item.serviceType == "ACCOMMODATION" &&
                        m.isSame(moment(item.startDate).startOf("day")) &&
                        m.isSame(moment(item.endDate).startOf("day")))
                  : moment(item.startDate).startOf("day").isSame(m, "day");
              }),
            });
          }
        }
      }
      this.panels = [...list.map((d, i) => i)];
      return list;
    },
  },
  methods: {
    onRefreshPrices(payload) {
      this.$emit("refreshPrices", payload);
    },
    onOrderNoChange(payload) {
      this.$emit("orderNoChange", payload);
    },
    onShowPriceAdjuster(payload) {
      this.$emit("showPriceAdjuster", payload);
    },
    onRecalculate() {
      console.log("day by day onRecalculate");
      this.$emit("onRecalculate");
    },
    onShowMoveDays(payload) {
      this.$emit("showMoveDays", payload);
    },
    onReorderSelectedServices(payload) {
      this.$emit("reorderSelectedServices", payload);
    },
    onCustomPriceToggle(payload) {
      this.$emit("customPriceToggle", payload);
    },
    onZeroSelectedServices(payload) {
      this.$emit("zeroSelectedServices", payload);
    },
    onShowPaxUpdater(payload) {
      this.$emit("showPaxUpdater", payload);
    },
    onRemoveSelectedServices(payload) {
      this.$emit("removeSelectedServices", payload);
    },
    onShowUpdateStatus(payload) {
      this.$emit("showUpdateStatus", payload);
    },
    onShowItiComps(payload) {
      this.$emit("showItiComps", payload);
    },
    onSupplierEdit(payload) {
      this.$emit("supplier-edit", payload);
    },
    onShowRemarksEdit(payload) {
      this.$emit("showRemarksEdit", payload);
    },
    onItemsListAction(payload) {
      this.$emit(payload.action, payload.payload);
    },
    onRatesSearch($event, day) {
      this.$emit("show-rs", {
        fieldName: "startDate",
        label: day.dateString,
      });
    },
    onAddItem($event, day) {
      this.$emit("addItem", {
        fieldName: "startDate",
        label: day.dateString,
      });
    },
    onAddAdhoc($event, day) {
      this.$emit("addAdhoc", {
        fieldName: "startDate",
        label: day.dateString,
      });
    },
    onAddTemplate($event, day) {
      this.$emit("addTemplate", {
        fieldName: "startDate",
        label: day.dateString,
      });
    },
    onAddCharge($event, day) {
      this.$emit("addCharge", {
        fieldName: "startDate",
        label: day.dateString,
      });
    },
    onAddFromAllocations($event, day) {
      this.$emit("addFromAllocations", {
        fieldName: "startDate",
        label: day.dateString,
      });
    },
    onTimeChange(payload) {
      this.$emit("timeChange", payload);
    },
    onIsIncludedChange(payload) {
      this.$emit("isIncludedChange", payload);
    },
    onIsOptionalChange(payload) {
      this.$emit("isOptionalChange", payload);
    },
  },
  watch: {
    openAll(newVal) {
      this.panels = newVal ? [...this.days.map((d, i) => i)] : [];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemsListDayByDay.vue